import { createCostPriceAnalysis, CostPriceDuplicateMenuItemApiError, fetchCostPriceAnalysesByRestaurant } from '../../../services/costPrice/costPriceService';
import type { SetupOverviewItem } from '../../../services/setupOverview/setupOverviewService';
import { winningDishAnalyses } from '../../../utils/reports/utilizationReport';

/** Resolve again before editing: another tab may have created, deleted or relinked this item. */
export async function ensureSetupItemAnalysis(item: SetupOverviewItem, categoryId: string | undefined, isCurrent: () => boolean) {
  const find = async () => winningDishAnalyses(
    (await fetchCostPriceAnalysesByRestaurant(item.restaurantId)).filter(analysis => analysis.restaurantId === item.restaurantId)
  ).get(item.itemName);
  const existing = await find();
  if (!isCurrent()) throw new Error('Setup editor context changed');
  if (existing) return existing;
  try {
    return await createCostPriceAnalysis({
      restaurantId: item.restaurantId, menuItemName: item.itemName, costPriceName: item.itemName,
      categoryId, ingredients: [],
    });
  } catch (error) {
    // Another editor won the create race. Reuse its exact-name dish instead of duplicating it.
    if (!(error instanceof CostPriceDuplicateMenuItemApiError)) throw error;
    const createdElsewhere = await find();
    if (!createdElsewhere) throw error;
    return createdElsewhere;
  }
}
